// =============================================
// System Admin Layout
// Kipikid - מערכת נוכחות ילדים בגנים
// =============================================

import { useEffect } from 'react';
import {
  Home, Users, Building2, Baby, Settings,
  Shield, Landmark, Package, FolderTree, ClipboardList, CalendarDays, Radio,
} from 'lucide-react';
import { AdminSidebarLayout } from '../../layouts/AdminSidebarLayout';
import type { NavItem } from '../../layouts/AdminSidebarLayout';
import { sysAdminColors } from '../../styles/colors';

const navItems: NavItem[] = [
  { path: '/sysadmin/dashboard', icon: Home, label: 'ראשי' },
  { path: '/sysadmin/organizations', icon: Landmark, label: 'ארגונים' },
  { path: '/sysadmin/staff', icon: Users, label: 'עובדים' },
  { path: '/sysadmin/kindergartens', icon: Building2, label: 'גנים' },
  { path: '/sysadmin/children', icon: Baby, label: 'ילדים' },
  { path: '/sysadmin/attendance-history', icon: ClipboardList, label: 'היסטוריית נוכחות' },
  { path: '/sysadmin/devices', icon: Radio, label: 'שערים' },
  { path: '/sysadmin/products', icon: Package, label: 'קטלוג מוצרים' },
  { path: '/sysadmin/categories', icon: FolderTree, label: 'קטגוריות הוצאה' },
  { path: '/sysadmin/calendar', icon: CalendarDays, label: 'לוח שנה ארצי' },
  { path: '/sysadmin/settings', icon: Settings, label: 'הגדרות' },
];

const SysAdminMobileTitle = (
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <Shield size={20} color={sysAdminColors.primary} />
    <h1 style={{ fontSize: '18px', fontWeight: 'bold', color: sysAdminColors.primary }}>
      KipiKid SysAdmin
    </h1>
  </div>
);

export default function SysAdminLayout() {
  useEffect(() => {
    document.title = 'קיפיקיד — מנהל מערכת';
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#7c3aed');
  }, []);

  return (
    <AdminSidebarLayout
      navItems={navItems}
      title="KipiKid SysAdmin"
      subtitle="מנהל מערכת"
      primaryColor={sysAdminColors.primary}
      primaryLight={sysAdminColors.primaryLight}
      loginPath="/sysadmin/login"
      allowedRoles={['sysadmin']}
      showOrgFilter={true}
      mobileTitle={SysAdminMobileTitle}
      sidebarClass="sysadmin-sidebar-desktop"
      mainClass="sysadmin-main-content-desktop"
      cssPrefix="sysadmin-md"
    />
  );
}
